export const authReducer = (state = false, action) => {
  switch (action.type) {
    case "auth":
      return action.payload;

    default:
      return state;
  }
};
export default authReducer;
